/**
 * useCopyRegistry Loads admin-editable UI strings from /api/copy?surface=...
 * Returns a get(key, fallback) helper. Strings are cached in sessionStorage.
 */
import { useEffect, useState, useCallback } from "react";
import axios from "axios";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;
const CACHE_KEY = (surface) => `phygital_copy_${surface}`;

export function useCopyRegistry(surface) {
  const [copy, setCopy] = useState(() => {
    try {
      const cached = sessionStorage.getItem(CACHE_KEY(surface));
      return cached ? JSON.parse(cached) : {};
    } catch { return {}; }
  });

  useEffect(() => {
    let cancelled = false;
    (async () => {
      try {
        const res = await axios.get(`${API}/copy?surface=${surface}`);
        if (cancelled) return;
        setCopy(res.data || {});
        sessionStorage.setItem(CACHE_KEY(surface), JSON.stringify(res.data || {}));
      } catch (err) {
        // silent fail fallback values used
      }
    })();
    return () => { cancelled = true; };
  }, [surface]);

  const get = useCallback((key, fallback = "") => {
    return copy[key] || fallback;
  }, [copy]);

  return { copy, get };
}
